import { sqDocumentConstants } from '../../_constants';
import { sqDocumentServices } from '../../_services';
import { alertActions, confirmPromptActions, sqActions, userActions, } from '../index';

export const sqDocumentActions = {
    createSqDocument,
    updateSqDocument,
    deleteSqDocument,
    getSqDocumentBySqDocNum,
    ExpiredDocuments,
    
};

function sqDocumentFetching() { return { type: sqDocumentConstants.SQ_DOCUMENT_FETCHING } }
function sqDocumentFetched() { return { type: sqDocumentConstants.SQ_DOCUMENT_FETCHED } }

function sqDocSubmitting() { return { type: sqDocumentConstants.SQ_DOCUMENT_SUBMITTING } }
function sqDocSubmitted() { return { type: sqDocumentConstants.SQ_DOCUMENT_SUBMITTED } }

function createSqDocument(values) {
    return dispatch => {
        dispatch(sqDocSubmitting());
        dispatch(userActions.notallowLeavePage());
        sqDocumentServices.createSqDocument(values)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(sqDocSubmitted());
                    dispatch(alertActions.success('SQ document added successfully'));
                    window.location.href = '/sales_quotation/draft/read/' + values.sqrefNum;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(sqDocSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateSqDocument(values) {
    return dispatch => {
        dispatch(sqDocSubmitting());
        dispatch(userActions.notallowLeavePage());
        sqDocumentServices.updateSqDocument(values)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(sqDocSubmitted());
                    dispatch(alertActions.success('SQ document updated successfully'));
                    window.location.href = '/sales_quotation/draft/read/' + values.sqrefNum;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(sqDocSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteSqDocument(id, ref) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        sqDocumentServices.deleteSqDocument(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('SQ document deleted successfully'));
                    dispatch(sqActions.getSqWTerms(ref));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function getSqDocumentBySqDocNum(sQDocNum) {
    return dispatch => {
        dispatch(sqDocumentFetching());
        sqDocumentServices.getSqDocumentBySqDocNum(sQDocNum)
            .then(
                sqDocument => {
                    dispatch(success(sqDocument))
                    dispatch(sqDocumentFetched());
                },
                error => {
                    dispatch(sqDocumentFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqDocument) { return { type: sqDocumentConstants.GET_SQ_DOCUMENT_BY_SQDOCNUM, sqDocument } }
}

function ExpiredDocuments(payload, ref) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        sqDocumentServices.ExpiredDocuments(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('SQ document expired successfully'));
                    dispatch(sqActions.getSqWTerms(ref));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}